import { PLANE_DEFAULT_Z } from '@Components/BigBrowse/BigBrowseConfig';
import type { GridCard } from '@Components/BigBrowse/Model/Classes/GridCard';
import type { PlaneTypes } from '@Components/BigBrowse/Model/ModelTypes';
import { a } from '@react-spring/three';
import { observer } from 'mobx-react-lite';
import type { ReactNode } from 'react';

type Props = {
  gridCard: GridCard<PlaneTypes.Layout_Merchandiser>;
  children?: ReactNode;
};

// Captures the space to be rendered from left to right of the screen
export const MerchandiserContentWrapper = observer(
  function MerchandiserContentWrapper({ gridCard, children }: Props) {
    return (
      <a.mesh position={[0, gridCard.worldPosition.y, PLANE_DEFAULT_Z]}>
        {children}
      </a.mesh>
    );
  }
);
